import { AppDispatch, RootState, store } from "../../../..";
import { ISearchRequest, ISuggestion } from "../../../../../models/Search";
import { MapInterfaceActionCreator } from "../../mapInterface/action.creators";
import { MapFilterActionCreators } from "../../main/mapFilters/action-creators";
import {
  DeleteCybersecurityActiveSuggestion,
  MapFilterActionsEnum,
  SetCybersecurityActiveSuggestion,
  SetCybersecurityCleanSuggestion,
  SetCybersecuritySuggestion,
  ToggleServiceCategory,
  CleanServiceCategory,
  ToggleCompanySize,
  SetRegistrationStartDate,
  CleanRegistrationDate,
  ToggleCompanyType,
  CleanCompanyType,
  ToggleServices,
  CleanServices,
  SetOtherServices,
  CleanOtherServices,
  SetCertifications,
  CleanCertifications,
  SetRegistrationEndDate,
} from "./types";
import { cybersecurityService } from "../../../../api/CybersecurityService";

export const CybersecurityFilterActionCreators = {
  setCleanAllCybersecurityFilters: () => (dispatch: AppDispatch) => {
    dispatch(MapInterfaceActionCreator.setPage(1));
    dispatch(MapInterfaceActionCreator.setOffset(0));
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecurityServiceCategory([])
    );
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecurityCompanySize([])
    );
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecurityRegistrationDate([])
    );
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecurityCompanyType([])
    );
    dispatch(CybersecurityFilterActionCreators.cleanCybersecurityServices([]));
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecurityOtherServices([])
    );
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecurityCertifications([])
    );
    dispatch(
      CybersecurityFilterActionCreators.cleanCybersecuritySuggestions([])
    );
    dispatch(MapFilterActionCreators.cleanKeyword([]));
  },

  toggleCybersecurityServiceCategory: (
    payload: string
  ): ToggleServiceCategory => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_SERVICE_CATEGORY,
    payload,
  }),
  cleanCybersecurityServiceCategory: (payload: []): CleanServiceCategory => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICE_CATEGORY,
    payload,
  }),

  toggleCybersecurityService: (payload: string): any => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_SERVICE,
    payload,
  }),

  cleanCybersecurityService: (payload: []): any => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICE,
    payload,
  }),

  toggleCybersecurityCompanySize: (payload: string): ToggleCompanySize => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_COMPANY_SIZE,
    payload,
  }),
  cleanCybersecurityCompanySize: (payload: []): any => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_COMPANY_SIZE,
    payload,
  }),
  setCybersecurityRegistrationStartDate: (
    payload: string
  ): SetRegistrationStartDate => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_REGISTRATION_START_DATE,
    payload,
  }),
  setCybersecurityRegistrationEndDate: (
    payload: string
  ): SetRegistrationEndDate => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_REGISTRATION_END_DATE,
    payload,
  }),
  cleanCybersecurityRegistrationDate: (payload: []): CleanRegistrationDate => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_REGISTRATION_DATE,
    payload,
  }),
  toggleCybersecurityCompanyType: (payload: string): ToggleCompanyType => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_COMPANY_TYPE,
    payload,
  }),
  toggleCybersecurityOtherServices: (payload: string): SetOtherServices => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_OTHER_SERVICES,
    payload,
  }),

  cleanCybersecurityCompanyType: (payload: []): CleanCompanyType => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_COMPANY_TYPE,
    payload,
  }),
  toggleCybersecurityServices: (payload: string): ToggleServices => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_SERVICES,
    payload,
  }),
  cleanCybersecurityServices: (payload: []): CleanServices => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SERVICES,
    payload,
  }),

  cleanCybersecurityOtherServices: (payload: []): CleanOtherServices => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_OTHER_SERVICES,
    payload,
  }),
  setCybersecurityCertifications: (payload: boolean): SetCertifications => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_CERTIFICATIONS,
    payload,
  }),
  cleanCybersecurityCertifications: (payload: []): CleanCertifications => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_CERTIFICATIONS,
    payload,
  }),
  setCybersecuritySuggestions: (
    payload: ISuggestion[]
  ): SetCybersecuritySuggestion => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_SUGGESTION,
    payload,
  }),
  getCybersecuritySuggestions:
    (data: ISearchRequest) => async (dispatch: AppDispatch) => {
      try {
        dispatch(MapFilterActionCreators.setIsSuggestionsLoading(true));
        const response = await cybersecurityService.fetchSuggestions(data);
        if (response) {
          const suggestions = response.data;
          const activeSuggestions = (store.getState() as RootState).mapFilters
            .activeSuggestions;
          const suggestionsWithoutActiveSuggestions = suggestions.filter(
            (suggestion: ISuggestion) =>
              !activeSuggestions.some(
                (activeSuggestion) => activeSuggestion.code === suggestion.code
              )
          );
          dispatch(
            CybersecurityFilterActionCreators.setCybersecuritySuggestions(
              suggestionsWithoutActiveSuggestions
            )
          );
        }
        dispatch(MapFilterActionCreators.setIsSuggestionsLoading(false));
      } catch (e: string | any) {
        dispatch(
          MapInterfaceActionCreator.errorDispatch(e?.response?.data?.detail)
        );
      }
    },
  setCybersecurityActiveSuggestions: (
    payload: ISuggestion
  ): SetCybersecurityActiveSuggestion => ({
    type: MapFilterActionsEnum.SET_CYBERSECURITY_ACTIVE_SUGGESTION,
    payload,
  }),
  cleanCybersecuritySuggestions: (
    payload: []
  ): SetCybersecurityCleanSuggestion => ({
    type: MapFilterActionsEnum.CLEAN_CYBERSECURITY_SUGGESTION,
    payload,
  }),
  deleteCybersecurityActiveSuggestion: (
    payload: ISuggestion
  ): DeleteCybersecurityActiveSuggestion => ({
    type: MapFilterActionsEnum.DELETE_CYBERSECURITY_ACTIVE_SUGGESTION,
    payload,
  }),
  addCybersecurityActiveSuggestion:
    (suggestion: ISuggestion) => (dispatch: AppDispatch) => {
      const activeSuggestions = (store.getState() as RootState)
        .cybersecurityMapFilters.activeSuggestions;

      if (activeSuggestions.includes(suggestion)) {
        return;
      }

      dispatch(
        CybersecurityFilterActionCreators.setCybersecurityActiveSuggestions(
          suggestion
        )
      );
    },
};
